import { useParams } from '@solidjs/router';
import Text from '../components/Text';
import BotManageNav from '../components/BotManageNav';
import ResourceAccessPanel from '../components/ResourceAccessPanel';
import styles from './BotManage.module.css';

export default function BotManageAccess() {
    const params = useParams();
    const botId = () => params.id || '';

    return (
        <div class={styles.container}>
            <BotManageNav botId={botId()} />

            <div class="fcard v">
                <h2 class={styles.sectionHeader}>
                    <i class="fa-solid fa-users-gear" /> <Text val="BOT_MANAGE_TAB_ACCESS" />
                </h2>
                <ResourceAccessPanel resourceId={botId()} />
            </div>
        </div>
    );
}
